// For use with Scale SERP - 125 requests per month - https://www.scaleserp.com/docs
export const SCALESERP_API_REQUEST_URL = "https://api.scaleserp.com/search";

const SCALESERP_AUTHENTICATION_KEY = "9CB346C3707148A78C953A2B5782E9EC";

export const SCALESERP_SEARCH_PARAMS = new URLSearchParams({
  api_key: SCALESERP_AUTHENTICATION_KEY,
  q: "",
  google_domain: "google.com",
  gl: "us",
  hl: "en",
  search_type: "images",
  images_size: "medium",
});
